angular.module('acme.view.application.importExport.exportJobExecution.controllers.exportJobExecutionController', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.directive.dataGrid',
  'acme.common.service.permissions',
  'acme.common.service.userPreferences',
  'acme.view.application.importExport.exportJobExecution.directives.exportJobExecutionOutputs',
])
.filter('importExportDate', ['$filter', 'UserPreferencesService', function($filter, UserPreferencesService) {
  return function(input) {
      return $filter('date')(input, UserPreferencesService.getDateTimeFormat('sortDateTime'));
  };
}])
.controller('ExportJobExecutionController', ExportJobExecutionController);


function ExportJobExecutionController(
  $window,
  $rootScope,
  $state,
  $q,
  $timeout,
  ImportJobsApiService,
  ImportExportsApiService,
  JOB_EXECUTION_STATUS_TITLE
) {
  Object.assign(this, {
    $window: $window,
    $rootScope: $rootScope,
    $state: $state,
    $q: $q,
    $timeout: $timeout,
    ImportJobsApiService: ImportJobsApiService,
    ImportExportsApiService: ImportExportsApiService,
    JOB_EXECUTION_STATUS_TITLE: JOB_EXECUTION_STATUS_TITLE
  });

  // TODO: update ui-router to 0.3.0 to avoid calling this manually
  this.$onInit();
}

/**
 * Angular lifecycle method $onInit
 * @public
 * @memberOf ImportExportJobController
 * @return {Undefined} -
 */
ExportJobExecutionController.prototype.$onInit = function () {
  var self = this;

  self.loading = true;
  self.jobId = this.$state.params.id;

  self.vm = {
    job: {},
    jobExecution: {},
    outputs: []
  };

  self.$rootScope.$broadcast('Application::contentTitleChange', {
    title: 'Import Export - Export Job Execution'
  });

  self.$rootScope.$on('$stateChangeStart', function () {
    self.$rootScope.$broadcast('Application::setOverlayStatus', null);
    self.loading = false;
  });

  self.$rootScope.$broadcast('Application::setOverlayStatus', self.JOB_EXECUTION_STATUS_TITLE.exporting);

  self._load(this.$state.params.id);
};

ExportJobExecutionController.prototype._load = function (id) {
  this._loadJob(this.$state.params.jobId);
  this.refresh();
};

ExportJobExecutionController.prototype._loadJob = function (id) {
  var self = this;

  self.ImportJobsApiService.get(id)
    .then(function (response) {
      self.vm.job = response.data;

      var jobTypeTitle = self.vm.job.jobType === 'EXPORT' ? 'Export' : 'Import'; // TODO create lookup

      self.$rootScope.$broadcast('Application::contentTitleChange', {
        title: jobTypeTitle + ' Job Execution',
        buttonLeft: {
          label: 'Back',
          action: function () {
            window.history.back();
          }
        }
      });
    });
};

ExportJobExecutionController.prototype._loadJobExecution = function (id) {
  var self = this;

  return self.ImportExportsApiService.get(id)
    .then(function (response) {
      self.vm.jobExecution = response.data;
    }, function () {
      if (self.loading) {
        self.$rootScope.$broadcast('Application::setOverlayStatus', self.JOB_EXECUTION_STATUS_TITLE.exportFailed);

        self.$timeout(function() {
          self.$rootScope.$broadcast('Application::setOverlayStatus', null);
          self.loading = false;
        }, 5000);
      }
    });
};

ExportJobExecutionController.prototype._loadOutputs = function (id) {
  var self = this;

  return self.ImportExportsApiService.getOutputs(id)
    .then(function (response) {
      self.vm.outputs = response.data;
    }, function () {
      if (self.loading) {
        self.$rootScope.$broadcast('Application::setOverlayStatus', self.JOB_EXECUTION_STATUS_TITLE.exportFailed);

        self.$timeout(function() {
          self.$rootScope.$broadcast('Application::setOverlayStatus', null);
          self.loading = false;
        }, 5000);
      }
    });
};

ExportJobExecutionController.prototype.refresh = function () {
  var self = this;

  this.$q.all([
    this._loadJobExecution(this.jobId),
    this._loadOutputs(this.jobId)
  ])
    .then(function () {
      if (self.testStatus('processing') && self.loading) {
        self.$rootScope.$broadcast('Application::setOverlayStatus', self.JOB_EXECUTION_STATUS_TITLE.exporting);

        self.$timeout(function() {
          self.refresh();
        }, 1000);
      } else {
        self.$rootScope.$broadcast('Application::setOverlayStatus', null);
        self.loading = false;
      }
    });
};

ExportJobExecutionController.prototype.testStatus = function (statuses) {
  return new RegExp('^(' + statuses + ')$','i').test(this.vm.jobExecution.status);
};

ExportJobExecutionController.prototype.getStatusTitle = function () {
  return this.JOB_EXECUTION_STATUS_TITLE[this.vm.jobExecution.status] || this.JOB_EXECUTION_STATUS_TITLE.unknown;
};

ExportJobExecutionController.$inject = [
  '$window',
  '$rootScope',
  '$state',
  '$q',
  '$timeout',
  'ImportJobsApiService',
  'ImportExportsApiService',
  'JOB_EXECUTION_STATUS_TITLE'
];
